import { render } from "./QuickLink.vue?vue&type=template&id=f0ca0f46&ts=true"
import script from "./QuickLink.vue?vue&type=script&lang=ts"
export * from "./QuickLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__